<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
    <!-- <div class="visible-lg bmw-lg-tool-report-sidebar" (window:orientationchange)="screenRotate($event)"> -->

  <div class="bmw-lg-tool-report-sidebar" (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-tool-report-sidebar-title">
      Group Shared Tools
    </div>
    <div class="toolbar-side-links pointer">
      <a [ngClass]="{'bmw-lg-active-link': docTitle === 'Complete Tool Report'}" (click)='highlightLink("Complete Tool Report")'>Complete Tool Report</a>
    </div>
    <div class="toolbar-side-links pointer">
      <a [ngClass]="{'bmw-lg-active-link': docTitle === 'Autoship Tool Report'}" (click)='highlightLink("Autoship Tool Report")'>Autoship Tool Report</a>
    </div>
    <!-- <div class="toolbar-side-links">
      <a href='mount/tool/Tool Warranty Program - _2014-11-12_14-05-38.jpg' target="_blank">Special Tool Parts Warranty</a>
    </div>
    <div class="toolbar-side-links">
      <a href='mount/tool/Tool Problems.pdf' target="_blank">Tool Problem Information</a>
    </div>
    <div class="toolbar-side-links">
      <a href='mount/tool/BMW Tool Kit52016.pdf' target="_blank">Required Special Tools List</a>
    </div>
    <div class="toolbar-side-links">
      <a href='mount/tool/CORA2018workshopequipment2272018.pdf' target="_blank">BMW Workshop Equipment List</a>
    </div> -->
    <div class="bmw-lg-obd-filter">
      <div style="font-weight:bold">Filter by</div>
      <div style="margin-top:15px">Service Bulletin</div>
      <div>
        <input placeholder="Enter SIB" id="sib" [(ngModel)]='inputSIB' class="bmw-tool-report-filter-input">
      </div>
      <!--
      <div style="margin-top:15px">Location</div>
      <div>
        <input placeholder="Enter Location" id="location" [(ngModel)]='inputLocation' class="bmw-tool-report-filter-input">
      </div>
      -->
      <div style="margin-top:15px">Series</div>
      <div>
        <input placeholder="Enter Series" id="series" [(ngModel)]='inputSeries' class="bmw-tool-report-filter-input">
      </div>
      <label class="bmw-onoffswitch-checkbox" style="margin-top: 20px">Autoships
        <input [(ngModel)]="checkAutoships" type="checkbox" name="onoffswitch">
        <span class="checkmark"></span>
      </label>
      <label class="bmw-onoffswitch-checkbox">External MFR Tool Warranty
        <input [(ngModel)]="checkExternalMFR" type="checkbox" name="onoffswitch">
        <span class="checkmark"></span>
      </label>
      <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" style="padding: 4px; margin-bottom: 20px" (click)='applyFilter()'>Apply Filter</div>
      <div class="bmw-button-secondary pointer" style="padding: 4px;" (click)='cancelFilter()'>Cancel Filter</div>
    </div>
  </div>
</div>

<!-- Ipad HTML] -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <!-- <div class="visible-md bmw-lg-tool-report-sidebar" (window:orientationchange)="screenRotate($event)"> -->

  <div class="bmw-lg-tool-report-sidebar" (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-tool-report-sidebar-title" style="font-size:20px">
      Group Shared Tools
    </div>
    <div class="toolbar-side-links pointer">
      <a [ngClass]="{'bmw-lg-active-link': docTitle === 'Complete Tool Report'}" (click)='highlightLink("Complete Tool Report")'>Complete Tool Report</a>
    </div>
    <div class="toolbar-side-links pointer">
      <a [ngClass]="{'bmw-lg-active-link': docTitle === 'Autoship Tool Report'}" (click)='highlightLink("Autoship Tool Report")'>Autoship Tool Report</a>
    </div>
    <!-- <div class="toolbar-side-links">
      <a href='mount/tool/Tool Warranty Program - _2014-11-12_14-05-38.jpg' target="_blank">Special Tool Parts Warranty</a>
    </div>
    <div class="toolbar-side-links">
      <a href='mount/tool/Tool Problems.pdf' target="_blank">Tool Problem Information</a>
    </div>
    <div class="toolbar-side-links">
      <a href='mount/tool/BMW Tool Kit52016.pdf' target="_blank">Required Special Tools List</a>
    </div>
    <div class="toolbar-side-links">
      <a href='mount/tool/CORA2018workshopequipment2272018.pdf' target="_blank">BMW Workshop Equipment List</a>
    </div> -->
    <div class="bmw-lg-obd-filter">
      <div style="font-weight:bold">Filter by</div>
      <div style="margin-top:15px">Service Bulletin</div>
      <div>
        <input placeholder="Enter SIB" id="sib" [(ngModel)]='inputSIB' class="bmw-tool-report-filter-input">
      </div>
      <!--
      <div style="margin-top:15px">Location</div>
      <div>
        <input placeholder="Enter Location" id="location" [(ngModel)]='inputLocation' class="bmw-tool-report-filter-input">
      </div>
      -->
      <div style="margin-top:15px">Model</div>
      <div>
        <input placeholder="Enter Series" id="series" [(ngModel)]='inputSeries' class="bmw-tool-report-filter-input">
      </div>
      <label class="bmw-onoffswitch-checkbox" style="margin-top: 20px">Autoships
        <input [(ngModel)]="checkAutoships" type="checkbox" name="onoffswitch">
        <span class="checkmark"></span>
      </label>
      <label class="bmw-onoffswitch-checkbox">External MFR Tool Warranty
        <input [(ngModel)]="checkExternalMFR" type="checkbox" name="onoffswitch">
        <span class="checkmark"></span>
      </label>
      <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" style="padding: 4px; margin-bottom: 20px" (click)='applyFilter()'>Apply Filter</div>
      <div class="bmw-button-secondary pointer" style="padding: 4px;" (click)='cancelFilter()'>Cancel Filter</div>
    </div>
  </div>
</div>

<!-- Tablet HTML -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <!-- <div class="visible-sm" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-sm-tool-report">
      <div class="bmw-sm-tool-report-title">Group Shared Tools</div>
      <!-- <div class="bmw-sm-tool-report-links" (click)='highlightLink("search")'>
        Search for a Tool
        <div style="float: right">
          <i class="material-icons">search</i>
        </div>
      </div> -->
      <div class="bmw-sm-tool-report-links">
        <a (click)='highlightLink("Complete Tool Report")'>Complete Tool Report
          <div style="float: right">
            <i class="material-icons">arrow_forward</i>
          </div>
        </a>
      </div>
      <div class="bmw-sm-tool-report-links">
        <a (click)='highlightLink("Autoship Tool Report")'>Autoship Tool Report
          <div style="float: right">
            <i class="material-icons">arrow_forward</i>
          </div>
        </a>
      </div>
      <div class="bmw-sm-tool-report-links">
        <a href='mount/tool/Tool Warranty Program - _2014-11-12_14-05-38.jpg' target="_blank">Special Tool Parts Warranty
          <div style="float: right">
            <i class="material-icons">picture_as_pdf
              <!-- {{ report?.content[0].documentFileType === "pdf" ? "picture_as_pdf" : report?.content[0].documentFileType === "zip" ? "file_download"
              : (report?.content[0].documentFileType === "xlsx") || (report?.content[0].documentFileType === "doc") ? "insert_drive_file"
              : report?.content[0].documentFileType === "jpg" ? "image": "arrow_forward" }} -->
            </i>
          </div>
        </a>
      </div>
      <div class="bmw-sm-tool-report-links">
        <a href='mount/tool/Tool Problems.pdf' target="_blank">Tool Problem Information
          <div style="float: right">
            <i class="material-icons">picture_as_pdf
              <!-- {{ report?.content[0].documentFileType === "pdf" ? "picture_as_pdf" : report?.content[0].documentFileType === "zip" ? "file_download"
              : (report?.content[0].documentFileType === "xlsx") || (report?.content[0].documentFileType === "doc") ? "insert_drive_file"
              : report?.content[0].documentFileType === "jpg" ? "image": "arrow_forward" }} -->
            </i>
          </div>
        </a>
      </div>
      <div class="bmw-sm-tool-report-links">
        <a href='mount/tool/BMW Tool Kit52016.pdf' target="_blank">Required Special Tools List
          <div style="float: right">
            <i class="material-icons">picture_as_pdf
              <!-- {{ report?.content[0].documentFileType === "pdf" ? "picture_as_pdf" : report?.content[0].documentFileType === "zip" ? "file_download"
              : (report?.content[0].documentFileType === "xlsx") || (report?.content[0].documentFileType === "doc") ? "insert_drive_file"
              : report?.content[0].documentFileType === "jpg" ? "image": "arrow_forward" }} -->
            </i>
          </div>
        </a>
      </div>
      <div class="bmw-sm-tool-report-links">
        <a href='mount/tool/CORA2018workshopequipment2272018.pdf' target="_blank">Workshop Equipment List
          <div style="float: right">
            <i class="material-icons">picture_as_pdf
              <!-- {{ report?.content[0].documentFileType === "pdf" ? "picture_as_pdf" : report?.content[0].documentFileType === "zip" ? "file_download"
              : (report?.content[0].documentFileType === "xlsx") || (report?.content[0].documentFileType === "doc") ? "insert_drive_file"
              : report?.content[0].documentFileType === "jpg" ? "image": "arrow_forward" }} -->
            </i>
          </div>
        </a>
      </div>
      <!-- <a *ngIf='!(report?.title === "Complete Tool Report" || report?.title === "Autoship Tool Report")' [href]='report?.content[0].documentFileName'
          target="_blank">
          {{report?.title}}
          <div style="float: right">
            <i class="material-icons">
              {{ report?.content[0].documentFileType === "pdf" ? "picture_as_pdf" : report?.content[0].documentFileType === "zip" ? "file_download"
              : (report?.content[0].documentFileType === "xlsx") || (report?.content[0].documentFileType === "doc") ? "insert_drive_file"
              : report?.content[0].documentFileType === "jpg" ? "image": "arrow_forward" }}
            </i>
          </div>
        </a>
        <a *ngIf='report?.title === "Complete Tool Report" || report?.title === "Autoship Tool Report"' target="_blank">
          {{report?.title}}
          <div style="float: right">
            <i class="material-icons">arrow_forward</i>
          </div>
        </a> -->
    </div>
  </div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-tool-report">
      <div class="bmw-xs-tool-report-title">Group Shared Tools</div>
      <!-- <div class="bmw-sm-tool-report-links" (click)='highlightLink("search")'>
        Search for a Tool
        <div style="float: right">
          <i class="material-icons">search</i>
        </div>
      </div> -->
      <div class="bmw-sm-tool-report-links">
        <a (click)='highlightLink("Complete Tool Report")'>Complete Tool Report
          <div style="float: right">
            <i class="material-icons">arrow_forward</i>
          </div>
        </a>
      </div>

      <div class="bmw-sm-tool-report-links">
        <a (click)='highlightLink("Autoship Tool Report")'>Autoship Tool Report
          <div style="float: right">
            <i class="material-icons">arrow_forward</i>
          </div>
        </a>
      </div>
      <div class="bmw-sm-tool-report-links">
        <a href='mount/tool/Tool Warranty Program - _2014-11-12_14-05-38.jpg' target="_blank">Special Tool Parts Warranty
          <div style="float: right">
            <i class="material-icons">picture_as_pdf
              <!-- {{ report?.content[0].documentFileType === "pdf" ? "picture_as_pdf" : report?.content[0].documentFileType === "zip" ? "file_download"
              : (report?.content[0].documentFileType === "xlsx") || (report?.content[0].documentFileType === "doc") ? "insert_drive_file"
              : report?.content[0].documentFileType === "jpg" ? "image": "arrow_forward" }} -->
            </i>
          </div>
        </a>
      </div>
      <div class="bmw-sm-tool-report-links">
        <a href='mount/tool/Tool Problems.pdf' target="_blank">Tool Problem Information
          <div style="float: right">
            <i class="material-icons">picture_as_pdf
              <!-- {{ report?.content[0].documentFileType === "pdf" ? "picture_as_pdf" : report?.content[0].documentFileType === "zip" ? "file_download"
              : (report?.content[0].documentFileType === "xlsx") || (report?.content[0].documentFileType === "doc") ? "insert_drive_file"
              : report?.content[0].documentFileType === "jpg" ? "image": "arrow_forward" }} -->
            </i>
          </div>
        </a>
      </div>
      <div class="bmw-sm-tool-report-links">
        <a href='mount/tool/BMW Tool Kit52016.pdf' target="_blank">Required Special Tools List
          <div style="float: right">
            <i class="material-icons">picture_as_pdf
              <!-- {{ report?.content[0].documentFileType === "pdf" ? "picture_as_pdf" : report?.content[0].documentFileType === "zip" ? "file_download"
              : (report?.content[0].documentFileType === "xlsx") || (report?.content[0].documentFileType === "doc") ? "insert_drive_file"
              : report?.content[0].documentFileType === "jpg" ? "image": "arrow_forward" }} -->
            </i>
          </div>
        </a>
      </div>
      <div class="bmw-sm-tool-report-links">
        <a href='mount/tool/CORA2018workshopequipment2272018.pdf' target="_blank">Workshop Equipment List
          <div style="float: right">
            <i class="material-icons">picture_as_pdf
              <!-- {{ report?.content[0].documentFileType === "pdf" ? "picture_as_pdf" : report?.content[0].documentFileType === "zip" ? "file_download"
              : (report?.content[0].documentFileType === "xlsx") || (report?.content[0].documentFileType === "doc") ? "insert_drive_file"
              : report?.content[0].documentFileType === "jpg" ? "image": "arrow_forward" }} -->
            </i>
          </div>
        </a>
      </div>
      <!-- <a *ngIf='!(report?.title === "Complete Tool Report" || report?.title === "Autoship Tool Report")' [href]='report?.content[0].documentFileName'
          target="_blank">
          {{report?.title}}
          <div style="float: right">
            <i class="material-icons">
              {{ report?.content[0].documentFileType === "pdf" ? "picture_as_pdf" : report?.content[0].documentFileType === "zip" ? "file_download"
              : (report?.content[0].documentFileType === "xlsx") || (report?.content[0].documentFileType === "doc") ? "insert_drive_file"
              : report?.content[0].documentFileType === "jpg" ? "image": "arrow_forward" }}
            </i>
          </div>
        </a>
        <a *ngIf='report?.title === "Complete Tool Report" || report?.title === "Autoship Tool Report"' target="_blank">
          {{report?.title}}
          <div style="float: right">
            <i class="material-icons">
              {{ report?.content[0].documentFileType === "pdf" ? "picture_as_pdf" : report?.content[0].documentFileType === "zip" ? "file_download"
              : (report?.content[0].documentFileType === "xlsx") || (report?.content[0].documentFileType === "doc") ? "insert_drive_file"
              : report?.content[0].documentFileType === "jpg" ? "image": "arrow_forward" }}
            </i>
          </div>
        </a> -->
    </div>
  </div>
</div>